export const DATA_TYPE = {
    NUMBER: 'NUMBER',
    BOOLEAN: 'BOOLEAN',
    STRING: 'STRING',
};
export const STREAM_TYPE = {
    ALARM: 'ALARM',
    ANOMALY: 'ANOMALY',
    ALARM_THRESHOLD: 'ALARM_THRESHOLD',
};
export const COMPARISON_OPERATOR = {
    LT: 'LT',
    GT: 'GT',
    LTE: 'LTE',
    GTE: 'GTE',
    EQ: 'EQ',
    CONTAINS: 'CONTAINS',
};
export const STATUS_ICON_TYPE = {
    error: 'error',
    active: 'active',
    normal: 'normal',
    acknowledged: 'acknowledged',
    snoozed: 'snoozed',
    disabled: 'disabled',
    latched: 'latched',
};
